export const getApiBaseUrl = (): string => {
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "development";
  
  // Hardcode known backend URLs
  if (ENVIRONMENT === "production") {
    return "https://backend.omnibutler.com";
  }
  
  if (ENVIRONMENT === "staging") {
    return "https://backend.staging.omnibutler.com";
  }
  
  // For PR previews and other dynamic environments, use the env variable
  const BACKEND_SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL || "localhost:8000";
  let apiBaseUrl = BACKEND_SERVER_URL.trim();
  
  // For development and PR preview environments
  if (/^https?:\/\//i.test(apiBaseUrl)) {
    // URL starts with http:// or https://, use as is
    return apiBaseUrl;
  } else {
    // URL does not start with http:// or https://
    // Use window.location.protocol for development
    let protocol = "http:";
    if (
      typeof window !== "undefined" &&
      window.location &&
      window.location.protocol
    ) {
      protocol = window.location.protocol;
    }
    apiBaseUrl = `${protocol}//${apiBaseUrl}`;
    return apiBaseUrl;
  }
};

export const getWebSocketBaseUrl = (): string | null => {
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "development";
  
  // Hardcode known backend URLs
  if (ENVIRONMENT === "production") {
    return "wss://backend.omnibutler.com";
  }
  
  if (ENVIRONMENT === "staging") {
    return "wss://backend.staging.omnibutler.com";
  }
  
  // For PR previews and other dynamic environments
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const backendServerUrl = process.env.REACT_APP_BACKEND_SERVER_URL || "localhost:8000";

  // Strip http:// or https:// from the backend server URL
  const strippedUrl = backendServerUrl.replace(/^https?:\/\//i, "");

  return `${protocol}//${strippedUrl}`;
};
